import { SystemCode } from '@/api'

export interface SystemCodeItem extends SystemCode {
  isSelected: boolean
}

// C0019
export const CollectionStatus = {
  Delete: '00', // 削除
  Removed: '01', // 除籍
  PreparingToAccept: '05', // 受入準備中
  Shelf: '10', // 書架
  Lending: '20', // 貸出中
  LendingUnregistered: '21', // 未登録貸出中
  ReceiveWaiting: '30', // 予約受取待
  ReceiveForwarding: '31', // 予約回送中
  LostProcedure: '40', // 紛失手続中
  Lost: '41', // 紛失
  Repairing: '50', // 修理中
  OtherForwarding: '70', // 他館回送中
  BookBinding: '80', // 製本
  Composed: '81', // 構成資料
  TempAccept: '90' // 仮受入
}

// C0052
export const OrderStatus = {
  Invalid: '0', // 無効
  Accept: '1', // 受入済
  TempAccept: '2', // 仮受入
  Ordering: '3', // 発注中
  Canceled: '4' // 発注取消
}

// C0060
export const ReserveStatus = {
  ReceiveWaiting: '1', // 受取待
  Preparation: '2', // 準備中
  Forwarding: '3', // 回送中
  ReturnWaiting: '4', // 返却待
  ForwardRequesting: '5' // 回送依頼中
}

// C0066
export const UserStatus = {
  Deleted: '0', // 削除
  Enabled: '1', // 有効
  Expelled: '2', // 除籍
  LendSuspended: '3', // 貸停
  Unknown: '9' // 不明
}

// C0090
export const LostType = {
  LostProcedure: '1', // 紛失手続き中
  Lost: '2', // 紛失
  LostUnknown: '3', // 紛失(不明)
  LostCancel: '4' // 紛失解除
}

// C0121
export const InspectionStatus = {
  New: '1', // 新規
  Entering: '2', // 入力中
  Updated: '3' // 更新済
}

// C0020
export const HandlingType = {
  latest: '00', // 最新号
  nonlending: '01', //	禁帯
  nonlead: '02', //	閲覧禁止
  assignedReading: '03', //	課題図書
  citrus: '04', //	シトラス
  feature: '05', //	特集コーナー
  storageLD: '08', //	保管ＬＤ
  other: '99', //	その他
  borrowed: 'SK', //	借用資料
  groupRental: 'XX', //	団体貸出用
  nonReserve: 'YN', //	予約不可
  removalCandidate: 'ZZ' //	除籍候補
}

// C0204
export const UserMailContactType = {
  reserve: '01', // 予約
  newArrival: '02', // 新着連絡
  remind: '03', // 督促連絡
  notice: '04', // お知らせ
  event: '05' // イベント
}

export const SchoolGradeCode = {
  FirstGrade: '1', // １年生
  ThirdGrade: '3', // ３年生
  SixthGrade: '6', // 6年生
  Teacher: 'A', // 教職員
  Graduation: 'X' // 卒業
}

// C0039
export const LendType = {
  General: '10', // 一般貸出
  // Special: '20' // 特別貸出、本プログラムでは廃止
  // Borrow: '30' // 借用貸出、本プログラムでは廃止
  Group: '35', // 団体貸出
  Extend: '40', // 貸出延長
  InsideReading: '50' // 館内閲覧
}

// C0032
export const Gender = {
  Unknown: '9' // 不明
}
